<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6666 5.83333C11.6666 4.91417 10.9191 4.16667 9.99996 4.16667C9.08079 4.16667 8.33329 4.91417 8.33329 5.83333C8.33329 6.7525 9.08079 7.5 9.99996 7.5C10.9191 7.5 11.6666 6.7525 11.6666 5.83333ZM13.3333 5.83333C13.3333 7.67167 11.8383 9.16667 9.99996 9.16667C8.16163 9.16667 6.66663 7.67167 6.66663 5.83333C6.66663 3.995 8.16163 2.5 9.99996 2.5C11.8383 2.5 13.3333 3.995 13.3333 5.83333ZM4.16663 16.6667C4.16663 13.45 6.78413 10.8333 9.99996 10.8333C13.2158 10.8333 15.8333 13.45 15.8333 16.6667C15.8333 17.1267 15.4608 17.5 15 17.5C14.5391 17.5 14.1666 17.1267 14.1666 16.6667C14.1666 14.3692 12.2975 12.5 9.99996 12.5C7.70246 12.5 5.83329 14.3692 5.83329 16.6667C5.83329 17.1267 5.46079 17.5 4.99996 17.5C4.53913 17.5 4.16663 17.1267 4.16663 16.6667Z"
      fill="#231F20"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="2"
      width="12"
      height="16"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6666 5.83333C11.6666 4.91417 10.9191 4.16667 9.99996 4.16667C9.08079 4.16667 8.33329 4.91417 8.33329 5.83333C8.33329 6.7525 9.08079 7.5 9.99996 7.5C10.9191 7.5 11.6666 6.7525 11.6666 5.83333ZM13.3333 5.83333C13.3333 7.67167 11.8383 9.16667 9.99996 9.16667C8.16163 9.16667 6.66663 7.67167 6.66663 5.83333C6.66663 3.995 8.16163 2.5 9.99996 2.5C11.8383 2.5 13.3333 3.995 13.3333 5.83333ZM4.16663 16.6667C4.16663 13.45 6.78413 10.8333 9.99996 10.8333C13.2158 10.8333 15.8333 13.45 15.8333 16.6667C15.8333 17.1267 15.4608 17.5 15 17.5C14.5391 17.5 14.1666 17.1267 14.1666 16.6667C14.1666 14.3692 12.2975 12.5 9.99996 12.5C7.70246 12.5 5.83329 14.3692 5.83329 16.6667C5.83329 17.1267 5.46079 17.5 4.99996 17.5C4.53913 17.5 4.16663 17.1267 4.16663 16.6667Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="20" height="20" fill="#F08B71" />
    </g>
  </svg>
</template>
